import { useState } from 'react';

import { SoftCard } from '@/components/ui/soft-card';
import { SectionHeader } from '@/components/ui/section-header';
import { Skeleton } from '@/components/ui/skeleton';
import { Toggle } from '@/components/ui/toggle';
import { useToast } from '@/components/ui/toast';
import { useWeeklyInsightsPreference } from '@/hooks/useWeeklyInsightsPreference';
import { SettingsHeader } from './components/SettingsHeader';

function NotificationsSkeleton() {
	return (
		<div className="max-w-3xl space-y-8">
			<Skeleton className="h-4 w-32" />
			<Skeleton className="h-10 w-72" />
			<Skeleton className="h-32" />
		</div>
	);
}

export function Notifications() {
	const { enabled, loading, save } = useWeeklyInsightsPreference();
	const { toast } = useToast();
	const [saving, setSaving] = useState(false);

	if (loading) return <NotificationsSkeleton />;

	const handleChange = async (next) => {
		setSaving(true);
		try {
			await save(next);
		} catch (err) {
			toast({ title: 'Could not save', description: err?.message ?? 'Try again', variant: 'destructive' });
		} finally {
			setSaving(false);
		}
	};

	return (
		<div className="max-w-3xl space-y-8">
			<SettingsHeader eyebrow="Account" title="Notifications" description="Choose what Unify emails you about." />

			<section>
				<SectionHeader
					eyebrow="Email"
					title="Weekly insights digest"
					sub="A short email each Monday with what's working, what changed, and what to look at next."
				/>
				<SoftCard className="!p-5 md:!p-6">
					<Toggle
						label="Send me the weekly insights digest"
						checked={!!enabled}
						disabled={saving}
						onChange={(event) => handleChange(event.target.checked)}
					/>
				</SoftCard>
			</section>
		</div>
	);
}
